import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { RegexUsername } from "configs/regex";
import { Field, Formik } from "formik";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { changePassUser } from "../../../../utils/action";
import {
  InputPassword,
  setTitleCase,
} from "../../../components/template/partials";

// inital values form
const initialValues = (autoComplete) => {
  return {
    username: autoComplete?.username ?? "",
    password: "",
    confirm_password: "",
  };
};

// form field validation schema
const validationSchema = Yup.object().shape({
  username: Yup.string()
    .required("Nama Pengguna wajib diisi!")
    .matches(RegexUsername, "Format Nama Pengguna tidak sesuai"),
  password: Yup.string().required("Kata Sandi wajib diisi!"),
  confirm_password: Yup.string()
    .required("Konfirmasi Sandi wajib diisi!")
    .oneOf(
      [Yup.ref("password"), null],
      "Konfirmasi Kata Sandi tidak sama dengan Kata Sandi"
    ),
});

export function ChangePassUser() {
  const [isLoading, setLoading] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const showDialog = location.state?.showDialog ?? false;
  const userData = location.state?.userData ?? null;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const onHide = () => {
    navigate(-1);
  };

  const handleFormSubmit = async (values) => {
    setLoading(true);
    const request = {
      username: values.username,
      password: values.password,
    };

    // send to backend
    try {
      await changePassUser(request);
      toast.success(setTitleCase("berhasil mengedit password pengguna"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-delete-user-title"
      className="dialog-container"
    >
      <DialogTitle id="responsive-dialog-delete-user-title">
        Ganti Password Pengguna
      </DialogTitle>
      <Divider />

      <DialogContent>
        <Formik
          enableReinitialize
          onSubmit={handleFormSubmit}
          initialValues={initialValues(userData)}
          validationSchema={validationSchema}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className="dialog-content-column">
              <img
                src="/assets/images/alert.webp"
                width="30%"
                height="30%"
                alt="delete-user images"
                loading="lazy"
              />
              <div className="dialog-content-spacing">
                <Grid container spacing={3}>
                  <Grid item md={12} xs={12}>
                    <Typography className="dialog-content-key-text">
                      NAMA PENGGUNA
                    </Typography>
                    <Typography
                      gutterBottom
                      className="dialog-content-value-text"
                    >
                      {userData?.username}
                    </Typography>
                    <Divider />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <Field
                      component={InputPassword}
                      name="password"
                      label="Kata Sandi"
                      size="small"
                      variant="outlined"
                      fullWidth
                      sx={{ mb: 2 }}
                    />
                    <Field
                      component={InputPassword}
                      name="confirm_password"
                      label="Konfirmasi Kata Sandi"
                      size="small"
                      variant="outlined"
                      fullWidth
                      sx={{ mb: 2 }}
                    />
                  </Grid>
                </Grid>
              </div>

              <Divider />
              <DialogActions>
                <Button
                  autoFocus
                  onClick={onHide}
                  color="error"
                  variant="contained"
                >
                  Batal
                </Button>
                <LoadingButton
                  autoFocus
                  loading={isLoading}
                  type="submit"
                  color="primary"
                  variant="contained"
                >
                  Simpan
                </LoadingButton>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}
